import FilterListIcon from "@mui/icons-material/FilterList";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import allison from "../../../.././../../Assets/Images/allisonBacker.jpg";
import haaland from "../../../.././../../Assets/Images/haaland.jpg";
import jamal from "../../../.././../../Assets/Images/jamal.jpg";
import messiVsPsg from "../../../.././../../Assets/Images/messivspsg.png";
import neymar from "../../../.././../../Assets/Images/neymar.jpg";
import ronaldo from "../../../.././../../Assets/Images/ronaldo.jpg";
import "./ProfileCat.css";
import ProfileCatMap from "./ProfileCatMap";

const ProfileCat = () => {
  const [toggleButton, setToggleButton] = useState({
    flag: 1,
    text: "Follow",
  });

  const history = useHistory();

  const { slug } = useParams();

  const [blockButton, setBlockButton] = useState({
    flag: 1,
    text: "Block",
  });

  const handleClick = () => {
    if (toggleButton.flag === 0) {
      setToggleButton({
        flag: 1,
        text: "Follow",
      });
    } else {
      setToggleButton({
        flag: 0,
        text: "UnFollow",
      });
    }
  };

  // const handleUnfollow = () => {
  //   history.push("/star-following-list");
  // }
  // const handleFollow = () => {
  //   history.push("/star-following-list");
  // }
  // const handleFollowUnFollow = () => {
  //   history.push("/star-follow-following-list");
  // }

  const handleBlock = () => {
    if (blockButton.flag === 0) {
      setBlockButton({
        flag: 1,
        text: "Block",
      });
    } else {
      setBlockButton({
        flag: 0,
        text: "UnBlock",
      });
    }
  };

  return (
    <>
      <div className="row">
        {/* {starCategoryList.map((singleData) => { */}
        <ProfileCatMap slug={slug} />;{/* })} */}
      </div>
    </>
  );
};

export default ProfileCat;
